import { Link } from "gatsby";
import * as React from "react";
//import HeaderMenu from "./HeaderMenu/HeaderMenu";
import { Segment, Icon, Container, Sidebar } from "semantic-ui-react";
import "../css/styles.css";
import "../css/responsive.css";
import "../css/semantic.min.css";
import "prismjs/themes/prism-okaidia.css";
import { Provider } from "react-redux";
import { store } from "../store";

export interface LayoutProps {
  location: {
    pathname: string;
  };
  children: any;
}

const Layout = (props: LayoutProps) => {
  const { pathname } = props.location;
  const isHome = pathname === "/";

  return (
    <Provider store={store}>
      <>
        <nav id="block-system-main-menu" role="navigation" className="block block--system block--menu block--system-main-menu">
          <ul className="menu">
            <li className="first leaf">
              <a href="/index.html" title="" >
                Etusivu
              </a>
            </li>
            <li className="leaf">
              <a href="/tutkimus-ihmisten-ja-eläinten-välisestä-suhteesta.html">
                Mistä on kyse?
              </a>
            </li>
            <li className="leaf">
              <a href="https://elaintehtaat.fi/kuvat-videot.html">Kuvat &amp; videot</a>
            </li>
            <li className="leaf">
              <a href="/video" className="active">Videodokumentti</a>
            </li>
            <li className="leaf">
              <a href="../medialle.html">Medialle</a>
            </li>
            <li className="last leaf">
              <a href="/english.html">In English</a>
            </li>
          </ul>
        </nav>

        {/* Render children pages */}
        <div style={{ paddingBottom: 60 }}>{props.children}</div>

        {/* Footer */}
        <Segment inverted vertical style={{ bottom: 0, width: "100%", paddingBottom: "5em" }}>
          <Container textAlign="center">
            <p>
            <strong>Yhteystiedot:</strong> Oikeutta eläimille / PL 362 / 00131 Helsinki<br />
<strong>Puhelin: </strong>044 722 3351 (klo 9-17) / 044 722 3352 (media)<br />
<strong>Sähköposti: </strong>info@oikeuttaelaimille.fi
            </p>
          </Container>
        </Segment>
      </>
    </Provider>
  );
};

export default Layout;

export const withLayout = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) =>
  class WithLayout extends React.Component<P & LayoutProps> {
    render() {
      return (
        <Layout location={this.props.location}>
          <WrappedComponent {...this.props} />
        </Layout>
      );
    }
  };
